import { saveCookie } from "src/utilities/tracking";

/**
 * The session token, shared with the rest of the brand's domain.
 *
 * localStorage belongs to this origin alone, so fraction.com cannot see that the visitor is signed
 * in to app.fraction.com. This cookie, scoped to the parent domain (`config.cookieDomain`), is how
 * it does: the statement reader sends it as a bearer header, and the "Go to dashboard" link keys
 * off it (packages/www/src/lib/auth.ts). Written and cleared alongside the localStorage token.
 */
export const SESSION_COOKIE = "fraction_auth_token";

/**
 * 400 days, the longest any browser keeps a cookie. Rewritten every time the app loads, so it only
 * lapses after 400 days away; login tokens themselves never expire.
 */
const MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

export function saveSessionCookie(token: string) {
  saveCookie(SESSION_COOKIE, token, {
    maxAge: MAX_AGE_SECONDS,
    secure: window.location.protocol === "https:",
  });
}

export function clearSessionCookie() {
  saveCookie(SESSION_COOKIE, "", { maxAge: 0 });
}
